<div class="container container-shadow py-5 mt-3 mb-5">
  <h3>{{ withheldIncomeTax.id ? 'Editing' : 'New' }} Withheld Income Tax</h3>
  <hr />
  <form #currentForm="ngForm" novalidate>
    <div class="row">
      <div class="col-12">
        <div class="row mt-2">
          <div class="col-sm-3 col-md-2"></div>
          <div class="col-sm-8 col-md-6">
            <div class="custom-control custom-checkbox" (click)="withheldIncomeTax.is_married = !withheldIncomeTax.is_married">
              <input name='is_married' ngDefaultControl type="checkbox" class="custom-control-input" [(ngModel)]="withheldIncomeTax.is_married" [checked]="withheldIncomeTax.is_married" />
              <label class="custom-control-label">Married?</label>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-3 col-md-2">
            <label>Minimum Wage</label>
          </div>
          <div class="col-sm-8 col-md-6">
            <input
              type="number"
              [ngClass]="{ 'is-invalid': minimum_wage.errors && (minimum_wage.errors.required || minimum_wage.errors.invalidNumber) && formSubmitted }"
              required
              #minimum_wage="ngModel"
              name="minimum_wage"
              [(ngModel)]="withheldIncomeTax.min"
              class="form-control"
              appNumberValidator
              ngDefaultControl
            />
            <div class="invalid-feedback">
              <div *ngIf="minimum_wage.errors && minimum_wage.errors.required">Minimum Wage is required</div>
              <div *ngIf="minimum_wage.errors && minimum_wage.errors.invalidNumber">Minimum Wage should be a number</div>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-3 col-md-2">
            <label>Maximum Wage</label>
          </div>
          <div class="col-sm-8 col-md-6">
            <input type="number" name="maximum_wage" ngDefaultControl [(ngModel)]="withheldIncomeTax.max" class="form-control" />
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-3 col-md-2">
            <label>Tax Rate</label>
          </div>
          <div class="col-sm-8 col-md-6">
            <input type="number" name="tax_rate" ngDefaultControl [(ngModel)]="withheldIncomeTax.rate" class="form-control" />
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-sm-3 col-md-2">
            <label>Tax Base</label>
          </div>
          <div class="col-sm-8 col-md-6">
            <input type="number" [ngClass]="{ 'is-invalid': tax_base.errors && (tax_base.errors.required || tax_base.errors.invalidNumber) && formSubmitted }" required #tax_base="ngModel" name="tax_base" ngDefaultControl [(ngModel)]="withheldIncomeTax.base" class="form-control" appNumberValidator />
            <div class="invalid-feedback">
              <div *ngIf="tax_base.errors && tax_base.errors.required">Tax Base is required</div>
              <div *ngIf="tax_base.errors && tax_base.errors.invalidNumber">Tax Base should be a number</div>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col text-center">
            <button type="button" class="btn btn-primary" [disabled]="formSubmitting" (click)="save(currentForm.form.valid)">
              {{ formSubmitting ? 'Saving' : 'Save' }}<span *ngIf="formSubmitting">&nbsp;<i class="fas fa-spinner fa-pulse fa-fw"></i></span></button
            >&nbsp;
            <button type="button" class="btn btn-secondary" [disabled]="formSubmitting" (click)="back()">Cancel</button>
            <span *ngIf="withheldIncomeTax.id">
              &nbsp;
              <button type="button" class="btn btn-danger" [disabled]="formSubmitting" (click)="delete()">Delete</button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
